import React, { useState } from 'react';
import { Avatar, AvatarProps, Box, Skeleton } from '@chakra-ui/react';

export const AvatarWithSkeleton = ({ ...props }: AvatarProps) => {
	const [isLoading, setIsLoading] = useState(!!props.src);

	return (
		<Box position="relative">
			{isLoading ? (
				<Skeleton
					position="absolute"
					zIndex={1}
					boxSize={props.boxSize}
					width={props.width}
					height={props.height}
					minW={props.minW}
					maxW={props.maxW}
					minH={props.minH}
					maxH={props.maxH}
					borderRadius={props.borderRadius}
				/>
			) : null}
			<Avatar
				opacity={isLoading ? 0 : 1}
				onLoad={() => setIsLoading(false)}
				onError={() => setIsLoading(false)}
				{...props}
			/>
		</Box>
	);
};
